import { getRootBrand } from './getRootBrand';
import { FormTracking } from './types';

export function useFormTracking(implementations: FormTracking.Implementations) {
  const tracking = (args: FormTracking.SubmitInput) => {
    try {
      const { brandId } = args ?? {};
      const root = getRootBrand(brandId);
      const keysOfImplementation = [root, brandId, 'common'];
      for (const key of keysOfImplementation) {
        if (key && typeof implementations[key] === 'function')
          implementations[key](args);
      }
    } catch (err) {
      console.error('Error in useFormTracking', err);
    }
  };
  return { tracking };
}
